export default {
  feedback: {
    usage_threshold: 'Minimaal bestelbedrag voor deze promo is (excl. bezorgkosten)',
    promo_code_added: 'Promotiecode toegepast',
    promo_code_removed: 'Promotiecode {{code}} verwijderd',
  },
};
